import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Icons } from 'src/app/models/icons.model';
import { UserModel } from 'src/app/models/user.model';

@Component({
  selector: 'app-user-picker',
  standalone: false,
  templateUrl: './user-picker.component.html',
  styleUrls: ['./user-picker.component.scss'],
})
export class UserPickerComponent implements OnInit {
  @Input()
  set users(value: UserModel[]) {
    this._users = value;
    this.initSearch();
  }
  @Input()
  caption: string = 'Select Users';
  @Input()
  isReady: boolean = true;

  filteredUsers: Observable<UserModel[]>;
  filter = new UntypedFormControl('');
  icons = new Icons();
  _users: UserModel[] = [];
  constructor() { }

  ngOnInit(): void {
    this.initSearch();
  }

  selectAll() {
    this._users.forEach((u) => (u.IsSelected = true));
  }

  selectNone() {
    this._users.forEach((u) => (u.IsSelected = false));
  }

  private initSearch() {
    this.filteredUsers = this.filter.valueChanges.pipe(
      startWith(''),
      map((text) => this.searchUsers(text))
    );
  }

  clearSearch() {
    this.filter.setValue('');
  }

  private searchUsers(text: string): UserModel[] {
    return this._users?.filter((user) => {
      const term = text.toLowerCase();
      return (
        user.Name?.toLowerCase().includes(term) ||
        user.EmailAddress?.toLowerCase().includes(term) ||
        user.Upn?.toLowerCase().includes(term)
      );
    });
  }
}
